<template>
  <div
    id="app"
    :class="[currentThemeClass,
             $store.state.browser ? $store.state.browser.name:'',
             $store.state.browser ? $store.state.browser.os:''
    ]"
  >
    <WaveSelector />
    <MainView />
  </div>
</template>

<script>
import WaveSelector from '@/components/utils/wave/WaveSelector.vue';
import MainView from './views/MainView.vue';

const { detect } = require('detect-browser');

export default {
  name: 'App',
  components: { MainView, WaveSelector },
  computed: {
    currentThemeClass() {
      return `${this.$store.state.theme}-theme`;
    },
  },
  watch: {
    $route() {
      this.updateTheme();
      this.checkCollectionAvailability();
    },
  },
  mounted() {
    this.checkCollectionAvailability();
    if (document.readyState !== 'complete') {
      window.addEventListener('load', () => {
        this.$store.commit('setLoaded', true);
      });
    } else {
      this.$store.commit('setLoaded', true);
    }
  },
  created() {
    const browser = detect();
    this.$store.commit('setBrowser', browser);
    this.updateTheme();
  },
  methods: {
    checkCollectionAvailability() {
      const collection = this.$currentCollection;
      if (collection && !collection.available && this.$route.name !== 'teaser') {
        // const target = this.$route.name === 'history' ? 'teaser-history' : 'teaser';
        const target = 'teaser';
        this.$router.replace({ name: target, params: { collectionId: collection.id } });
      }
    },
    // Update the theme to match the collection in the route or default collection is targetted collection is not available or doesn't exist
    updateTheme() {
      if (this.$route.params.collectionId) {
        const collectionId = this.$route.params.collectionId;
        const collection = this.$getCollectionById(collectionId);
        this.$store.commit('setTheme', collection);
      }
    },
  },
};
</script>

<style lang="stylus">
  #app {
    border-top: 1px solid var(--main-color);
  }
</style>
